import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Skeleton } from "@/components/ui/skeleton";
import { MessageSquare, ThumbsUp, ThumbsDown, Home, HeartHandshake, ShieldAlert } from "lucide-react";

const Stat = ({ label, value, icon: Icon }) => (
  <div className="rounded-xl border-2 border-[#E5E5E0] bg-white p-4" data-testid={`qa-stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="flex items-center gap-2 text-[#6B7280] text-xs font-semibold"><Icon className="w-4 h-4" />{label}</div>
    <p className="mt-1 font-display text-2xl text-[#0B192C]">{value}</p>
  </div>
);

export default function AskQA() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/public/ask/admin/qa").then((r) => setD(r.data)).catch(() => setD({ error: true })); }, []);
  if (!d) return <div className="p-8 max-w-6xl mx-auto"><Skeleton className="h-96 w-full rounded-xl" /></div>;
  const t = d.totals || {};
  return (
    <div className="p-6 sm:p-8 max-w-6xl mx-auto" data-testid="ask-qa-page">
      <PageHeader title="Ask Nauticus QA" subtitle="Product-quality monitoring — no transcript content shown." icon={MessageSquare} />
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3 mt-6">
        <Stat label="Sessions" value={t.sessions ?? 0} icon={MessageSquare} />
        <Stat label="Households" value={t.households_created ?? 0} icon={Home} />
        <Stat label="Deflections" value={t.deflections ?? 0} icon={ShieldAlert} />
        <Stat label="Handoffs" value={t.handoffs ?? 0} icon={HeartHandshake} />
        <Stat label="Helpful" value={t.feedback_helpful ?? 0} icon={ThumbsUp} />
        <Stat label="Not helpful" value={t.feedback_not_helpful ?? 0} icon={ThumbsDown} />
      </div>
      <div className="mt-8 rounded-xl border-2 border-[#E5E5E0] bg-white overflow-hidden">
        <div className="px-4 py-3 bg-[#F8F8F5] border-b font-bold text-[#0B192C] text-sm">Recent sessions</div>
        <table className="w-full text-sm" data-testid="qa-sessions-table">
          <thead><tr className="text-left text-[#6B7280]">
            <th className="p-3">Started</th><th className="p-3">Questions</th><th className="p-3">Deflections</th><th className="p-3">Household</th><th className="p-3">Advisor</th>
          </tr></thead>
          <tbody>
            {(d.sessions || []).length === 0 && <tr><td colSpan="5" className="p-6 text-center text-[#6B7280]">No sessions yet.</td></tr>}
            {(d.sessions || []).map((s, i) => (
              <tr key={i} className="border-t border-[#EEE]" data-testid="qa-session-row">
                <td className="p-3">{(s.created_at || "").slice(0, 16).replace("T", " ")}</td>
                <td className="p-3">{s.question_count}</td>
                <td className="p-3">{s.deflection_count}</td>
                <td className="p-3">{s.household_created ? "✓" : "—"}</td>
                <td className="p-3">{s.advisor_handoff ? "✓" : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
